import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ModalController, NavParams, Platform} from '@ionic/angular';
import {Subscription} from 'rxjs';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {HelperService} from '../../service/helper.service';
import {ApiService} from "../../service/api.service";
import {TranslateConfigService} from "../../service/translate-config.service";

@Component({
  selector: 'app-lsc-xd',
  templateUrl: './lsc.component.html',
  styleUrls: ['./lsc.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LscXocDiaComponent implements OnInit, OnDestroy {
  @ViewChild('lscXD', {static: false}) elLscXD: ElementRef;
  listHis = [];
  pageNum = 1;
  totalPages = 0;
  subscriptionReload: Subscription;
  subscriptionScreenOri: Subscription;
  isLandscape = false;

  constructor(
    private modalCtr: ModalController,
    private navParams: NavParams,
    private hpService: HelperService,
    protected apiService: ApiService,
    private screenOrientation: ScreenOrientation,
    public platform: Platform,
    public translateConfigService: TranslateConfigService
  ) {
    this.listHis = this.convertData(navParams.data.dataHis.content);
    this.totalPages = navParams.data.dataHis.totalPages;
    this.subscriptionReload = this.hpService.getObserverHisBetXD().subscribe(
      data => {
        if (data === 'reloadHisBet') {
          this.pageNum = 1;

          this.hpService.observableLoading.next(true);
          this.apiService.getHisBetXD((this.pageNum - 1)).subscribe(
            res => {
              this.hpService.observableLoading.next(false);
              this.listHis = this.convertData(res.content);
              this.totalPages = res.totalPages;
            },
            error => {
              console.log(error);
            },
            () => {
            }
          );
        }
      },
      error => {
      },
      () => {
      }
    );

    platform.ready().then((readySource) => {
      this.detectScreenOrient();
    });
    this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
      () => {
        this.detectScreenOrient();
      }
    );
  }

  detectScreenOrient() {
    setTimeout(() => {
      const pH = this.platform.height();
      const pW = this.platform.width();
      let hGame = 0;
      if (pW > pH) {
        this.isLandscape = true;
        hGame = 305;
      } else if (pW < pH) {
        this.isLandscape = false;
        hGame = 400;
      }

      if (pH < hGame) {
        this.elLscXD.nativeElement.style.transform = `scale(${(pH / hGame)})`;
      } else {
        this.elLscXD.nativeElement.style.transform = `scale(1)`;
      }
    }, 100);
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptionReload.unsubscribe();
    this.subscriptionScreenOri.unsubscribe();
  }

  ionViewWillEnter() {

  }

  async closeModal() {
    await this.modalCtr.dismiss();
  }

  pageHis(event, flag) {
    event.preventDefault();
    if (flag === 'prev' && this.pageNum > 1) {
      this.pageNum -= 1;
    } else if (flag === 'next' && this.pageNum <= this.totalPages) {
      this.pageNum += 1;
    } else {
      return;
    }

    this.hpService.observableLoading.next(true);
    this.apiService.getHisBetXD((this.pageNum - 1)).subscribe(
      data => {
        this.hpService.observableLoading.next(false);
        this.listHis = this.convertData(data.content);
      },
      error => {
        console.log(error);
      },
      () => {
      }
    );
  }

  convertData(data) {
    data.map(item => {
      item.betamount = this.hpService.convertMoneyTxt(item.betamount);
      item.refundamount = this.hpService.convertMoneyTxt(item.refundamount);
      item.winamount = this.hpService.convertMoneyTxt(item.winamount);
      if (item.resul == 'undefined' || item.result === null || item.result.length == 0) {
        item.result = ['x', 'x', 'x', 'x'];
        item.txtBet = 'x';
      } else {
        // tslint:disable-next-line:no-eval
        item.result = eval(item.result);
        let resultTotal = item.result[0] + item.result[1] + item.result[2] + item.result[3];

        if (resultTotal == 4 || resultTotal == 0) {
          item.txtBet = this.translateConfigService.getTranslateService().instant('MINI-GAME.chan');
        } else if (resultTotal == 3 || resultTotal == 1) {
          item.txtBet = this.translateConfigService.getTranslateService().instant('MINI-GAME.le');
        } else {
          item.txtBet = this.translateConfigService.getTranslateService().instant('MINI-GAME.hoa')
        }
      }
      item.time = '';
      const betTime = new Date(item.bettime);
      item.time = this.hpService.getDateTimeHH_MM_SS(betTime);
      item.date = this.hpService.getDateTimeByFormat(betTime, 'DD/MM/YYYY');
      return item;
    });
    return data;
  }
}
